<template>
    <div v-if="badge">
        <div class="cd-fixed-badge-description">
            <span class="title">{{ badge.title }}</span>
            <span class="description" v-html="labels.get('always_displayed_'+badge.code)"></span>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps(['item']);
    const labels = useLabels();

    const badge = computed(() => {
        if(!props.item?.attributes_special) return null;
        const attrs = props.item?.attributes_special;        
        return attrs.filter(attr => attr.attribute_code === 'posebne_oznake' && attr.always_displayed && attr.always_displayed == '1').at(-1);
    });
</script>